import React from 'react';
import { FiMaximize2 } from 'react-icons/fi';

// Global Components
import ButtonLink from 'components/ButtonLink';

interface Props {
    rowId: string;
    isRowHovered?: boolean;
    onClick: (rowId: string) => void;
}

export class VirtualizedTableCellExpandButtonComponent extends React.PureComponent<
    Props
> {
    handleClick = (): void => {
        const { rowId, onClick } = this.props;
        onClick(rowId);
    };

    render(): React.ReactElement | null {
        const { isRowHovered } = this.props;

        if (!isRowHovered) {
            return null;
        }

        return (
            <ButtonLink
                onClick={this.handleClick}
                buttonProps={{
                    style: { marginTop: 2 }
                }}
            >
                <FiMaximize2 size="17" />
            </ButtonLink>
        );
    }
}

export default VirtualizedTableCellExpandButtonComponent;
